import "./Publication.scss";
import 
// LabelLang, 
{ LabelLangString } from "component/LabelLang/label-lang";
import { FormattedMessage } from "react-intl";
import { DateFormater } from "functions/dateTimeFormat";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "configs/AppConfig";
import { GetStudyPeriod } from "functions/getStudyPeriod";
import { useSelector } from "react-redux";

const Publication = ({ item, subject = null, isNew = null }) => {

  const currentLocale = useSelector(({ theme }) => theme.locale);
  
  return (
    <div className="col-12 browsetopic-item publication">
      <Link
        to={`../publications/${item?.id}`}
        target="_blank"
      >
        <div className="row gx-0 gy-1">
          <div className={`${isNew ? "col-md-3" : "col-lg-2 col-md-3"}`}>
            <div className="browsetopic-i-img">
              <img
                loading="lazy"
                className=""
                src={
                  item?.cover
                    ? `${API_BASE_URL}/${item?.cover}`
                    : process.env.PUBLIC_URL + "/image/book.png"
                }
                alt="publication-img"
              />
            </div>
          </div>
          <div
            className={`${isNew ? "col-md-9" : "col-lg-10 col-md-9"}`}
          >
            <div className="total-details">
              <div className="title">
                <h6>
                  {LabelLangString({
                    id: "name",
                    defaultValue: item?.name,
                    currentLocale: currentLocale,
                    translations: item?.publicationTranslations,
                  })}
                </h6>
              </div>
              <div className="row g-0 browsetopic-dateils publication">
                <div className={`${isNew ? "col-md-10" : "col-md-5"}`}>
                  <ul>
                    <li>
                      <span>
                        <FormattedMessage id="publication-type" />
                      </span>
                      <p>
                        {LabelLangString({
                          id: "name",
                          defaultValue: item?.publicationType?.name,
                          currentLocale: currentLocale,
                          translations: item?.publicationType?.publicationTypeTranslations,
                        })}
                      </p>
                    </li>
                    <li>
                      <span>
                        <FormattedMessage id="topic" />
                      </span>
                      <p className="cav">
                        {subject ? (
                          LabelLangString({
                            id: "title",
                            defaultValue: subject?.title,
                            currentLocale: currentLocale,
                            translations: subject?.subjectTranslations,
                          })
                        ) : (
                          LabelLangString({
                            id: "title",
                            defaultValue: item?.subject?.title,
                            currentLocale: currentLocale,
                            translations: item?.subject?.subjectTranslations,
                          })
                        )}
                      </p>
                    </li>
                    <li>
                      <span>
                        <FormattedMessage id="study-period" />
                      </span>
                      <p>
                        {/* <DateFormater value={`${item?.publicationDetail?.year ? item?.publicationDetail?.year : '2023'}-${item?.publicationDetail?.month ? item?.publicationDetail?.month : '12'}`} type={"monthYear"} /> */}
                        {Array.isArray(item?.publicationDetail) ? (
                          item?.publicationDetail[0]?.studyPeriodAsString ? (
                            // <LabelLang
                            //   id="name"
                            //   defaultValue={
                            //     item?.publicationDetail?.studyPeriod?.name
                            //   }
                            //   translations={
                            //     item?.publicationDetail?.studyPeriod
                            //       ?.studyPeriodTranslations
                            //   }
                            // />
                            GetStudyPeriod(
                              item?.yearTypeId,
                              item?.periodic?.id,
                              item?.publicationDetail[0]?.studyPeriodAsString
                            )
                          ) : (
                            <FormattedMessage id="data-not-found" />
                          )
                        ) : item?.publicationDetail?.studyPeriodAsString ? (
                          // <LabelLang
                          //   id="name"
                          //   defaultValue={
                          //     item?.publicationDetail?.studyPeriod?.name
                          //   }
                          //   translations={
                          //     item?.publicationDetail?.studyPeriod
                          //       ?.studyPeriodTranslations
                          //   }
                          // />
                          GetStudyPeriod(
                            item?.yearTypeId,
                            item?.periodic?.id,
                            item?.publicationDetail?.studyPeriodAsString
                          )
                        ) : (
                          <FormattedMessage id="data-not-found" />
                        )}
                      </p>
                    </li>
                  </ul>
                </div>
                <div className={`${isNew ? "col-md-10" : "col-md-5"}`}>
                  <ul>
                    <li>
                      <span>
                        <FormattedMessage id="issue-date" />
                      </span>
                      <p>
                        {Array.isArray(item?.publicationDetail) ? (
                          item?.publicationDetail[0]?.releaseDate ? (
                            <DateFormater
                              value={item?.publicationDetail[0]?.releaseDate}
                              type={"monthYear"}
                            />
                          ) : (
                            <FormattedMessage id="data-not-found" />
                          )
                        ) : item?.publicationDetail?.releaseDate ? (
                          <DateFormater
                            value={item?.publicationDetail?.releaseDate}
                            type={"monthYear"}
                          />
                        ) : (
                          <FormattedMessage id="data-not-found" />
                        )}
                      </p>
                    </li>
                    <li>
                      <span>
                        <FormattedMessage id="periodical" />
                      </span>
                      <p>
                        {LabelLangString({
                          id: "name",
                          defaultValue: item?.periodic?.name,
                          currentLocale: currentLocale,
                          translations: item?.periodic?.periodicTranslations,
                        })}
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="col-md-2 d-flex justify-content-end align-items-end">
                  <div className="row-r mt-0">
                    <Link
                      to={`../publications/${item?.id}`}
                      target="_blank"
                      className="main-btn "
                    >
                      <span>
                        <FormattedMessage id="more" />
                      </span>
                      <i className="fas fa-ellipsis-h"> </i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default Publication;
